<script>

  /**
   * Prop imports
   */
  // eslint-disable-next-line
  export let data;

</script>

<style>
  h1 {
    font-size: 30px;
    padding:  10px 20px;
    background-color: #333;
    line-height: 1.2em;
    margin-bottom: 20px;
  }

  .logo {
    margin-top: 20px;
    width: 250px;
  }

  .page {
    height: 100%;
    background-color: #333;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
    /* scroll-snap-align: start; */
  }

  .recirc-container {
    text-align: center;
    max-width: 900px;
  }

  .article-boxes {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(3, 1fr);
  }

  .article-box {
    background-position: center;
    background-size: cover;
    height: 200px;
    background-color: #3a3a3a;
    color: white;
    display: flex;
    align-items: flex-end;
  }

  .meta-box {
    background-color: #444444cc;
    width: 100%;
    padding: 20px;
    text-align: left;
    min-height: 100px;
  }

  .meta-title {
    font-size: 18px;
    line-height: 1.2em;
  }

  .meta-author {
    font-size: 12px;
    margin-bottom: 10px;
  }

  a:hover {
    text-decoration: none;
  }

  @media screen and (max-width: 600px) {
    h1 {
      font-size: 30px;
    }

    .article-boxes {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }

    .article-box {
      height: 120px;
    }

    .meta-box {
      min-height: 55px;
      padding: 10px;
    }

    .meta-title {
      font-size: 14px;
    }

    .meta-author {
      font-size: 8px;
      margin-bottom: 5px;
    }

    .recirc-container {
      width: 100%;
    }
  }
</style>

<div class="page">
  <div class="recirc-container">
    <h1>{data.articlesDesc}</h1>
    <div class="article-boxes">
      {#each data.articles as article}
        {#if article.url}
        <a target="_blank" href="{article.url}" >
          <div class="article-box" style="background-image: url('{article.img}')">
            <div class="meta-box">
              <h4 class="meta-author">{article.author}</h4>
              <h3 class="meta-title">{article.title}</h3>
            </div>
          </div>
        </a>
        {:else}
          <div class="article-box" style="background-image: url('{article.img}')">
            <div class="meta-box">
              <h4 class="meta-author">{article.author}</h4>
              <h3 class="meta-title">{article.title}</h3>
            </div>
          </div>
        {/if}
      {/each}
    </div>
    <img class="logo" src="logo.png" alt="TNL Logo">
  </div>
</div>
